const __WEBPACK_NAMESPACE_OBJECT__ = require("@ant-design/icons-svg/es/asn/UserOutlined");